import React from 'react';

import serverApi from '../../utils/serverApi.js';
import validator from 'validator';

/**
 * A higher ticket component wrapper that loads info about a ticket.
 *
 * @param {Object} WrappedComponent
 * @returns {Object}
 */
export default function ticketLoadByIdHOC(WrappedComponent) {
  /**
   * The TicketLoadById higher ticket component.
   */
  class TicketLoadById extends React.Component {
    /**
     * @constructor
     * @param {{}} props
     * @param {{}} componentContext
     */
    constructor(props, componentContext) {
      super(props, componentContext);

      this.state = {
        ticketId: null,
        isLoading: false,
        ticket: null,
        error: null,
        invalidVerification: false
      };
    }

    /**
     * Gets the ticket data for the given ticket id.
     *
     * @param {number} ticketId
     */
    loadTicket = (ticketId) => {
      this.setState({
        ticketId,
        isLoading: true,
        ticket: null,
        error: null,
      }, () => {
        serverApi.ticketGetById(ticketId).then((response) => {
          this.setState({
            isLoading: false,
            ticket: this.mapResponseToTicket(response),
            error: null,
            invalidVerification: false
          });
        }, (error) => {
          this.setState({
            isLoading: false,
            ticket: null,
            error,
          });
        });
      });
    };

    /**
     * Verifies then gets ticket if verified.  When not verified will remove credentials and set state as invalidVerification
     * which will load the verification component
     * 
     * @param {number} ticketId
     */
    verifyAndGetTicket = (ticketId) => {
      this.setState({
        ticketId,
        isLoading: true,
        ticket: null,
        error: null,
      }, async () => {
        const credentials = sessionStorage.getItem('credentials');
        const dataType = validator.isEmail(credentials) === true ? 'email' : 'phone';

        try {
          const verifiedResp = await serverApi.lookVerifyById(dataType, credentials, ticketId)
          const verified = verifiedResp.data === true

          if (!verified) {
            sessionStorage.removeItem('credentials')
            this.setState({
              isLoading: false,
              ticket: null,
              error: null,
              invalidVerification: true
            });
            return
          }

          const ticketDataResp = await serverApi.ticketGetById(ticketId)

          this.setState({
            isLoading: false,
            ticket: this.mapResponseToTicket(ticketDataResp),
            error: null,
            invalidVerification: false
          });
        } catch (error) {
          if (error.message === 'Network Error') {
            this.setState({
              isLoading: false,
              ticket: null,
              error,
            });
            return
          }
          sessionStorage.removeItem('credentials')

          this.setState({
            isLoading: false,
            ticket: null,
            error: null,
            invalidVerification: true
          });
        }
      });
    };

    /**
     * Maps the Axios response to the ticket data.
     *
     * @param {{data: object}} response
     * @returns {object|null}
     */
    mapResponseToTicket = (response) => {
      if (!response || !response.data) {
        return null;
      }

      return response.data;
    };

    /**
     * Renders the WrappedComponent.
     *
     * @returns {Object}
     */
    render() {
      const newProps = {
        ticketLoadById: {
          verifyAndGetTicket: this.verifyAndGetTicket,
          getTicket: this.loadTicket,
          isLoading: this.state.isLoading || false,
          ticket: this.state.ticket || null,
          error: this.state.error,
        },
        invalidVerification: this.state.invalidVerification || false
      };

      return <WrappedComponent {...this.props} {...newProps} />
    }
  }

  TicketLoadById.propTypes = {};

  return TicketLoadById;
}



// WEBPACK FOOTER //
// ./src/components/hoc/ticketLoadByIdHoc.js